// extracted by mini-css-extract-plugin
export default {"wrapper-title":"styles_wrapper-title__WnQ-I","title":"styles_title__0kSV7","title-long":"styles_title-long__HL0nK","date":"styles_date__ga5vZ","number":"styles_number__QzFPO"};